import {articleTestIds} from '@shared/Articles/ArticleTestIds';
import classNames from '@sindresorhus/class-names';
import {
  generateFullDateFormat,
  generateShortDateFormat,
} from '@utils/articles/generateDateFormat';
import Image from 'next/image';
import {useState} from 'react';

import EditIcon from '@ui-kit/src/assets/Icons/Edit.svg';
import TimeIcon from '@ui-kit/src/assets/Icons/time.svg';

import styles from './ArticleDateTime.module.scss';

type Props = {
  timeToRead?: number;
  updatedAt: string;
  createdAt: string;
  className?: string;
  isArticlePage?: boolean;
};

const handleArticleIsEdited = (createdAt: string, updatedAt: string) => {
  const createdDate = new Date(createdAt);
  const updatedDate = new Date(updatedAt);

  // Получаем временные метки в миллисекундах
  const createdTime = createdDate.getTime();
  const updatedTime = updatedDate.getTime();

  // Сравниваем разницу во времени
  const oneMinuteInMilliseconds = 60 * 1000;
  return updatedTime - createdTime >= oneMinuteInMilliseconds;
};

export const ArticleDateTime = ({
  timeToRead,
  updatedAt,
  createdAt,
  className,
  isArticlePage = false,
}: Props) => {
  const [dateTooltipShown, setDateTooltipShown] = useState(false);
  const [timeTooltipShown, setTimeTooltipShown] = useState(false);
  const isArticleEdited = handleArticleIsEdited(createdAt, updatedAt);

  return (
    <div
      className={classNames(styles.timeInfo, className)}
      data-testid={articleTestIds.proStoreArticlePageDate}
    >
      <div
        className={classNames(styles.date, {[styles.clickable]: isArticlePage})}
        onMouseOver={() => setDateTooltipShown(true)}
        onMouseLeave={() => setDateTooltipShown(false)}
      >
        {isArticleEdited && isArticlePage && (
          <Image src={EditIcon} alt="" width={20} height={20} />
        )}
        {generateShortDateFormat(updatedAt)}
        {dateTooltipShown && isArticlePage && (
          <div className={styles.tooltip}>
            {`Статья ${isArticleEdited ? 'обновлена' : 'написана'} ${generateFullDateFormat(updatedAt)}`}
          </div>
        )}
      </div>

      {timeToRead && (
        <div
          className={classNames(styles.time, {
            [styles.clickable]: isArticlePage,
          })}
          onMouseOver={() => setTimeTooltipShown(true)}
          onMouseLeave={() => setTimeTooltipShown(false)}
        >
          <Image src={TimeIcon} width={20} height={20} alt="" />
          {timeToRead} мин.
          {timeTooltipShown && isArticlePage && (
            <div className={styles.tooltip}>
              {`Время на чтение ${timeToRead} мин.`}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
